import { gql } from '__generated__/gql';

export const VIDEO_NOTIFICATIONS_SETTING_QUERY = gql(/* GraphQL */ `
  query videoNotificationsSetting($frontend: String!, $name: String!) {
    sessionUserTeamRelation {
      id
      frontendSettings(first: 1, frontend: $frontend, name: $name) {
        edges {
          node {
            id
            name
            value
            modified
          }
        }
      }
    }
  }
`);

export const TIKTOK_VIDEO_ANIMATION_STATUS_QUERY = gql(/* GraphQL */ `
  query tiktokVideoAnimationStatus($id: ID!) {
    tiktokSingleVideoAd(id: $id) {
      id
      latestImageAnimation {
        id
        status
      }
    }
  }
`);

export const VIDEO_AD_GENERATION_STATUS_QUERY = gql(/* GraphQL */ `
  query videoAdGenerationStatus($id: ID!) {
    videoAdGeneration(id: $id) {
      id
      status
      voiceoverVideoFile {
        id
      }
    }
  }
`);
